//THIS USE WHEN YOU NEED TO SHOW FABRIC INSIDE BOXES
function changePreviewVariantsBox()
{      
    var totalPro = $("#totalPro").val();
    var valPreview = $("#valPreview").val();
      if(valPreview == 2)
      {
       	$("#SingleOptionSelector-0").val(1).change();
     
      }
}
  


//WHEN MOUSE OUT
function size0VariantsBox(nameInput, id0)
{
  var info = $("#info").val();
  var showS = $("#valSize").val();

  /*variants before*/   
  var valueBeforeTitleVariantsOne=$("#valueBeforeTitleVariantsOne").val();
  var valueBeforeTitleVariantsTwo=$("#valueBeforeTitleVariantsTwo").val();
  var valueBeforeTitleVariantsThree=$("#valueBeforeTitleVariantsThree").val();

  if(nameInput != info 
     && nameInput != valueBeforeTitleVariantsOne 
     && nameInput != valueBeforeTitleVariantsTwo 
     && nameInput != valueBeforeTitleVariantsThree ){
    document.getElementById(nameInput).style.filter="blur(0px)";
    document.getElementById("txt-"+nameInput).style.display="none"; 
    document.getElementById(nameInput).style.boxShadow= "0px 0px 0px #999";
  }
}
  
  
//MOUSE OVER
function showSizeVariantsBox(nameZize, id)
{

    $("#showSize").empty();
    $("#showSize").append(nameZize);
    document.getElementById("txt-"+nameZize).style.display="none";
    
    var valueBeforeTitleVariantsOne=$("#valueBeforeTitleVariantsOne").val();
    var valueBeforeTitleVariantsTwo=$("#valueBeforeTitleVariantsTwo").val();
    var valueBeforeTitleVariantsThree=$("#valueBeforeTitleVariantsThree").val();

    document.getElementById(nameZize).style.boxShadow= "2px 2px 5px #999";
    document.getElementById("txt-"+nameZize).style.display="inline";
   
}

  
//WHE USER PRESS CLICK 
function fnChangeBorderVariantsBox(boxId, id, title, titleVariants)
{
   $("#valSize").val(boxId);
   var showEmail = $("#showEmail").val();
   var valShow = $("#valShow").val();
   var str = boxId;
   var s=$('#info').val();
   $("#id").val(str).change();
   $("#a").val(2).change();
   
   $("#SingleOptionSelector-1").val(str).change();
   
   var nVariantsOne=$("#nVariants-One").val();
   var nVariantsTwo=$("#nVariants-Two").val();
   var nVariantsThree=$("#nVariants-Three").val();
  
   /*before variants*/ 
   var beforeTitleVariantsOne=$("#beforeTitleVariantsOne").val();
   var valueBeforeTitleVariantsOne=$("#valueBeforeTitleVariantsOne").val();
   var beforeTitleVariantsTwo=$("#beforeTitleVariantsTwo").val();
   var valueBeforeTitleVariantsTwo=$("#valueBeforeTitleVariantsTwo").val();
   var beforeTitleVariantsThree=$("#beforeTitleVariantsThree").val();
   var valueBeforeTitleVariantsThree=$("#valueBeforeTitleVariantsThree").val();


   //when user make click in box
   if(boxId != valueBeforeTitleVariantsOne && boxId != valueBeforeTitleVariantsTwo && boxId != valueBeforeTitleVariantsThree ){
      document.getElementById("txt-"+boxId).style.display="inline";
      document.getElementById(boxId).style.boxShadow= "2px 2px 5px #999";
        if(id == 2){
        }else{
           $('#showButton').html("");
        }
	}
  
 	var typeShowOne = $("#typeShowOne").val();
    var typeShowTwo = $("#typeShowTwo").val();
  	var typeShowThree = $("#typeShowThree").val();
    var data = $("#info").val();
    $("#showSize").empty();
    $("#showSize").append(boxId);
    document.getElementById(boxId).style.border = "solid #EAEBED 1px";
    document.getElementById(boxId).style.border ="solid black 3px";
  
   //quit the style of before box
    if(boxId != valueBeforeTitleVariantsOne){
      if(beforeTitleVariantsOne == titleVariants)
      {
        document.getElementById("txt-"+valueBeforeTitleVariantsOne).style.display="none";
        document.getElementById(valueBeforeTitleVariantsOne).style.boxShadow= "0px 0px 0px #999";
        document.getElementById(valueBeforeTitleVariantsOne).style.border ="solid black 0px";
      }
    }

    if(boxId != valueBeforeTitleVariantsTwo){
      if(beforeTitleVariantsTwo == titleVariants)
      {
        document.getElementById("txt-"+valueBeforeTitleVariantsTwo).style.display="none";
        document.getElementById(valueBeforeTitleVariantsTwo).style.boxShadow= "0px 0px 0px #999";
        document.getElementById(valueBeforeTitleVariantsTwo).style.border ="solid black 0px";
      }
    }

    if(boxId != valueBeforeTitleVariantsThree){
      if(beforeTitleVariantsThree == titleVariants){
        document.getElementById("txt-"+valueBeforeTitleVariantsThree).style.display="none";
        document.getElementById(valueBeforeTitleVariantsThree).style.boxShadow= "0px 0px 0px #999";
        document.getElementById(valueBeforeTitleVariantsThree).style.border ="solid black 0px";
      } 
    }
  

    //SAVE BEFORE POSITION
    if(nVariantsOne == titleVariants){
   	  $("#SingleOptionSelector-0").val(boxId).change();
      $("#beforeTitleVariantsOne").val(titleVariants);
      $("#valueBeforeTitleVariantsOne").val(boxId);
      $("#typeShowOne").val(id);
    }

    if(nVariantsTwo == titleVariants){
      $("#beforeTitleVariantsTwo").val(titleVariants);
      $("#valueBeforeTitleVariantsTwo").val(boxId);
      $("#typeShowTwo").val(id);
    }

    if(nVariantsThree == titleVariants){
        $("#SingleOptionSelector-2").val(boxId).change();
      $("#beforeTitleVariantsThree").val(titleVariants);
      $("#valueBeforeTitleVariantsThree").val(boxId);
      $("#typeShowThree").val(id);
    }
  

    $("#info").val(boxId);
} 




